import { Pipe, PipeTransform } from '@angular/core';
import { ChargeType, Optional } from '@lib/interfaces';
import { LoadTransactionType, TransactionExtendedType, TransactionICExtendedType } from '@lib/enums';

@Pipe({
    standalone: true,
    name: 'transactionType',
})
export class TransactionTypePipe implements PipeTransform {
    public transform(value: Optional<TransactionExtendedType | TransactionICExtendedType | LoadTransactionType | ChargeType>): string {
        switch (value) {
            case TransactionExtendedType.PURCHASE:
                return 'Purchase';

            case TransactionExtendedType.CASH_WITHDRAWAL:
                return 'Cash withdrawal';

            case TransactionExtendedType.REFUND:
                return 'Refund';

            case TransactionExtendedType.BALANCE_INQUIRY:
                return 'Balance inquiry';

            case TransactionExtendedType.ACCOUNT_VERIFICATION:
                return 'Account verification';

            case TransactionExtendedType.WALLET_DEBIT:
                return 'Wallet debit';

            case TransactionExtendedType.WALLET_CREDIT:
                return 'Wallet credit';

            case TransactionICExtendedType.WALLET_CREDIT_IC:
                return 'Payment received';

            case TransactionExtendedType.INITIAL_LOAD:
                return 'Wallet Initial Credit';

            case TransactionExtendedType.WALLET_DEBIT_REVERSAL:
                return 'Wallet Debit Reversal';

            case TransactionExtendedType.WALLET_CREDIT_REVERSAL:
                return 'Wallet Credit Reversal';

            case TransactionExtendedType.QUASI_CASH:
                return 'Quasi Cash';

            case TransactionExtendedType.FUNDS_TRANSFER:
                return 'Fund Transfer';

            case TransactionExtendedType.WALLET_TRANSFER:
                return 'Wallet transfer';

            case TransactionExtendedType.WALLET_TRANSFER_FX:
                return 'Wallet transfer - FX';

            case TransactionExtendedType.OCT:
                return 'Oct';

            case TransactionExtendedType.AFT:
                return 'Aft';

            case LoadTransactionType.HOLD:
                return 'Hold';

            case LoadTransactionType.POST:
                return 'Post';

            case LoadTransactionType.RELEASE:
                return 'Release';

            case TransactionExtendedType.WALLET_DEBIT_MONEYGRAM:
                return 'MG Send Transfer';

            case TransactionExtendedType.WALLET_DEBIT_REVERSAL_MONEYGRAM:
                return 'Reverse MG Send Transfer';

            case TransactionExtendedType.EXCHANGE_TRANSFER:
                return 'Exchange Transfer';

            case TransactionExtendedType.WALLET_TOP_UP_VIA_CARD:
                return 'Wallet Top-up via Card';

            case TransactionExtendedType.UTILITY_PAYMENT:
                return 'Bill Payment';

            case ChargeType.LATE_PAYMENT:
                return 'Late Payment';

            case ChargeType.MAINTENANCE:
                return 'Maintenance';

            case ChargeType.FINANCIAL_CHARGES:
                return 'Financial Charges';

            default:
                return '';
        }
    }
}
